export default "__VITE_ASSET__D60hxZ3E__"